<template>
  <section v-if="!hasData" class="revenue-container">
    <div class="revenue-header">
      <span :class="!isWhite ? 'header-title' : 'header-title-white'">{{ header }}</span>
      <img
          loading="lazy"
          :src="headerIcon"
          class="header-icon"
          alt=""
      />
    </div>
    <p v-if="!hasData" :class="isWhite?'revenue-message-white':'revenue-message'">
      Geen gegevens gevonden. Upload een databestand om de omzet te berekenen
    </p>
    <button
        v-if="!hasData&&isWhite&&useAuth().canUpload()"
        class="upload-button"
        tabindex="0"
        aria-label="Upload een bestand"
        @click="showModal()"
    >
      Bestand uploaden
    </button>
    <span v-if="hasData||!isWhite"
          :class="!isWhite ? 'comparison-text' : 'comparison-text-white'">Vergeleken met de vorige maand</span>

  </section>
  <div v-else class="card-header">
    <div class="revenue-header">
      <span :class="!isWhite ? 'header-title' : 'header-title-white'">{{ header }}</span>
      <img
          loading="lazy"
          :src="headerIcon"
          class="header-icon"
          alt=""
      />
    </div>
    <div>
      <div class="metric-value" v-if="hasData">
        <span :class="!isWhite ? 'amount' : 'amount-white'">€ {{ formatNumber(totalCost) }}</span>
        <div class="percentage" :class="changeAmount>0?'positive':'negative'">
          <img
              loading="lazy"
              :src="changeAmount>0?'/assets/arrow-up.svg':'/assets/arrow-down.svg'"
              class="trend-icon"
              alt="Upward trend"
          />
          <span>{{ formatNumber(changeAmount) }}%</span>
        </div>
      </div>
      <div class="comparison">
        <span v-if="hasData||!isWhite"
              :class="!isWhite ? 'comparison-text' : 'comparison-text-white'">Vergeleken met de vorige maand</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {defineEmits} from "vue";
import {useAuth} from "../../composables/useAuth";

const formatNumber=(value: number)=> {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};
const emit = defineEmits(['showModal']);

const showModal = () => {
  emit('showModal');
};
const props = defineProps({
  header: {
    type: String,
    required: true
  },
  headerIcon: {
    type: String,
    required: true
  },
  totalCost: {
    type: Number,
    required: false
  },
  changeAmount: {
    type: Number,
    required: false
  },
  isWhite: {
    type: Boolean,
    required: false,
    default: false
  },
  hasData: {
    type: Boolean,
    required: true,
    default: false
  },
  downAmount: {
    type: String,
    required: false
  }
});

</script>
<style scoped>

.revenue-container {
  border-radius: 8px;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 6px 0;
}

.revenue-header {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--Neutral-background, #f7f8fc);
  justify-content: center;
}

.revenue-title {
  margin: auto 0;
  font-size: inherit;
  font-weight: normal;
}

.revenue-icon {
  aspect-ratio: 0.94;
  object-fit: contain;
  object-position: center;
  width: 16px;
  margin: auto 0;
}

.revenue-message {
  width: 100%;
  margin-top: 6px;
  gap: 3px;
  font-size: 10px;
  text-align: center;
  line-height: 14px;
}

.revenue-message-white {
  color: var(--Neutral-5, #ffffff);
  width: 100%;
  margin-top: 6px;
  gap: 3px;
  font-size: 10px;
  text-align: center;
  line-height: 14px;
}

.upload-button {
  align-self: center;
  border-radius: 8px;
  background: var(--secondary-secondary, #ff9f1c);
  margin-top: 6px;
  min-height: 24px;
  gap: 4px;
  font-size: 8px;
  color: var(--Neutral-1, #fcfcfc);
  font-weight: 700;
  line-height: 16px;
  padding: 4px 8px;
  border: none;
  cursor: pointer;
}

.upload-button:focus {
  outline: 2px solid var(--Neutral-1, #fcfcfc);
  outline-offset: 2px;
}

@media (max-width: 991px) {
  .revenue-header {
    white-space: initial;
  }
}

.metric-message-white {
  color: var(--Neutral-5, #ffffff);
  text-align: center;
  font-size: 10px;
  line-height: 14px;
  margin: 6px 0;
}

.metric-message {
  text-align: center;
  font-size: 10px;
  line-height: 14px;
  margin: 6px 0;
}


.upload-button {
  background: var(--secondary-secondary, #ff9f1c);
  border-radius: 8px;
  color: var(--Neutral-1, #fcfcfc);
  font-size: 8px;
  font-weight: 700;
  line-height: 16px;
  padding: 4px 8px;
  border: none;
  cursor: pointer;
}

.card-header {
  border-radius: 12px;
  display: flex;
  width: 80%;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 0;
}

.header-content {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.header-title {
  color: var(--Neutral-5, #191a1f);
  font: 500 16px Montserrat, sans-serif;
}

.header-title-white {
  color: var(--Neutral-5, #ffffff);
  font: 500 16px Montserrat, sans-serif;
}

.header-icon {
  aspect-ratio: 1;
  object-fit: contain;
  width: 24px;
}

.metric-value {
  display: flex;
  margin-top: 8px;
  width: 100%;
  align-items: center;
  gap: 4px;
  justify-content: center;
  padding: 8px 0;
}

.amount {
  color: var(--Neutral-5, #191a1f);
  font: 700 24px Montserrat, sans-serif;
}

.amount-white {
  color: var(--Neutral-5, #ffffff);
  font: 700 24px Montserrat, sans-serif;
}

.percentage {
  display: flex;
  align-items: center;
  font: 500 10px/1.6 Montserrat, sans-serif;
}

.percentage.positive {
  color: var(--green-5, #35aa09);
}

.percentage.negative {
  color: var(--red-3, #e51a1a);
}

.trend-icon {
  aspect-ratio: 1;
  object-fit: contain;
  width: 16px;
}

.comparison {
  display: flex;
  margin-top: 8px;
  width: 100%;
  flex-direction: column;
  font-size: 10px;
  justify-content: center;
  padding: 4px 0;
}

.trend {
  align-self: center;
  display: flex;
  color: var(--Neutral-5, #191a1f);
  align-items: center;
  font: 500 10px/1.6 Montserrat, sans-serif;
}

.trend-white {
  align-self: center;
  display: flex;
  color: var(--Neutral-5, #ffffff);
  align-items: center;
  font: 500 10px/1.6 Montserrat, sans-serif;
}

.comparison-text {
  color: var(--Neutral-5, #191a1f);
  text-align: center;
  font: 400 10px/18px Montserrat, sans-serif;
}

.comparison-text-white {
  color: var(--Neutral-5, #ffffff);
  text-align: center;
  font: 400 10px/18px Montserrat, sans-serif;
}

</style>